<template>
    <div>
        <b-card-header
            v-b-toggle="`accordion${themeLayer.customId}`"
            header-tag="header"
            class="p-0 m-0 d-flex"
            role="tab"
            data-toggle="collapse"
            :smt-ng-filter-expand="themeLayer.customId"
        >
            <x-checkbox
                :id="`cboxthmelayer${themeLayer.customId}`"
                :name="`cboxthmelayer${themeLayer.customId}`"
                :value="hasSelectedItems"
                :indeterminate="isIndeterminate"
                plain
                :enableClickEvent="true"
                @change="$_onChangeLayerCBox($event)"
                @click.stop
                :text="themeLayer.title"
            >
            </x-checkbox>
            <!-- Expand/collapse icon -->
            <em
                v-show="themeLayer.filters"
                class="ml-auto fa iconCollapseExpand"
            ></em>
        </b-card-header>
        <b-collapse
            :id="`accordion${themeLayer.customId}`"
            role="tabpanel"
            :visible="isExpanded"
        >
            <b-card-body>
                <filter-options
                    v-for="filter in layerFilterSettings"
                    :key="`${filter.settings.id}`"
                    @update="
                        $_updatedFilter({
                            filter: $event,
                            themeId: themeLayer.themeId,
                            layerId: themeLayer.customId
                        })
                    "
                    :overrideSelected="checkboxSelected"
                    :filterData="filter.settings"
                    :layerId="themeLayer.customId"
                />
            </b-card-body>
        </b-collapse>
    </div>
</template>

<script>
    import { DOMAIN_TYPE } from '../../../../constants';
    import FilterOptions from './FilterOptions.vue';

    export default {
        name: 'layer-filters',

        components: { 'filter-options': FilterOptions },

        data() {
            return {
                checkboxSelected: null,
                isIndeterminateChild: false
            };
        },

        props: {
            themeLayer: { type: Object, required: true },
            appliedFilters: { type: Array, required: true },
            isExpanded: { type: Boolean, required: false, default: false }
        },

        computed: {
            appliedLayerFilters: function () {
                return this.appliedFilters.filter(
                    ({ layerId, filter }) =>
                        layerId === this.themeLayer.customId &&
                        filter.selected === true &&
                        filter.visible === true
                );
            },
            hasSelectedItems: function () {
                return this.appliedLayerFilters.length > 0;
            },
            isIndeterminate: function () {
                return (
                    this.hasSelectedItems &&
                    (this.appliedLayerFilters.length <
                        this.themeLayer.filters.length ||
                        this.isIndeterminateChild)
                );
            },
            layerFilterSettings() {
                function getFilterNotSelected(filter) {
                    filter.settings.selected = false;
                    return filter;
                }
                // appliedFilters gets same fingerprint as original themeLayer.filters
                const appliedFilters = this.appliedFilters.map(({ filter }) => ({
                    settings: filter
                }));

                // use the settings from appliedFilters if available otherwise the original settings
                // filters not in appliedFilters need to get settings.selected set to false to show it as not selected
                return this.themeLayer.filters.map(
                    (filter) =>
                        appliedFilters.find(
                            (appliedFilter) =>
                                appliedFilter.settings.id === filter.settings.id
                        ) || getFilterNotSelected(filter)
                );
            }
        },

        methods: {
            $_updatedFilter({ filter, themeId, layerId }) {
                this.isIndeterminateChild =
                    filter.domainType === DOMAIN_TYPE.ALL_VALUES &&
                    filter.value?.length > 0 &&
                    filter.value.length < filter.feedbackDomain.keyvalues.length;

                if (
                    this.isIndeterminateChild ||
                    (!this.checkboxSelected && filter.selected)
                ) {
                    this.checkboxSelected = null;
                }
                this.$emit('update', { filter, themeId, layerId });
            },

            $_onChangeLayerCBox(active) {
                this.checkboxSelected = active;
            }
        },

        watch: {
            appliedLayerFilters: function (newVal, oldVal) {
                if (
                    !this.checkboxSelected &&
                    newVal.length === this.themeLayer.filters.length
                ) {
                    this.checkboxSelected = null;
                }
                if (this.checkboxSelected !== false && newVal.length === 0) {
                    this.checkboxSelected = false;
                }
            }
        }
    };
</script>

<style scoped>
.card-header {
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0) !important;
    border-bottom: 0px !important;
}

.card-body {
    padding: 0.15rem 0rem 0rem 1.25rem;
}
</style>
